import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "../contexts/ContentContext";
import TermsModal from "./TermsModal";
import { FooterBrand, FooterNav, FooterPracticeLinks, FooterContact } from "./FooterSections";

export default function Footer() {
  const { firm, practiceAreas } = useContent();
  return (
    <footer className="bg-[#0c1729] text-stone-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-10">
          <FooterBrand firm={firm} />
          <FooterNav />
          <FooterPracticeLinks practiceAreas={practiceAreas} />
          <FooterContact firm={firm} />
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="text-xs text-stone-500">
            &copy; {new Date().getFullYear()} {firm.name}. All rights reserved.
          </div>
          <div className="flex flex-wrap items-center gap-4 text-xs">
            <Link to="/pay" className="text-stone-400 hover:text-white" data-testid="footer-pay-online">
              Online Payments
            </Link>
            <span className="opacity-40 text-stone-500">|</span>
            <TermsModal
              trigger={
                <span className="inline-flex items-center gap-2 px-4 py-2 border border-[#b8924a]/40 text-[#d4b87a] hover:bg-[#b8924a] hover:text-white hover:border-[#b8924a] transition-colors uppercase tracking-[0.18em] text-[10px] font-medium">
                  Terms of Use / Disclaimer
                </span>
              }
            />
          </div>
        </div>

        <p className="text-[10px] text-stone-600 mt-6 leading-relaxed max-w-4xl">
          The information you obtain at this site is not, nor is it intended to be, legal advice. You should consult an attorney for advice regarding your individual situation. Contacting us does not create an attorney-client relationship.
        </p>
      </div>
    </footer>
  );
}
